export const GET_WEAVEFACTOR_REQUEST = 'GET_WEAVEFACTOR_REQUEST';
export const GET_WEAVEFACTOR_DATA = 'GET_WEAVEFACTOR_DATA';
export const GET_WEAVEFACTOR_ERROR = 'GET_WEAVEFACTOR_ERROR';

export const CREATE_WEAVEFACTOR_REQUEST = 'CREATE_WEAVEFACTOR_REQUEST';
export const CREATE_WEAVEFACTOR_DATA = 'CREATE_WEAVEFACTOR_DATA';
export const CREATE_WEAVEFACTOR_ERROR = 'CREATE_WEAVEFACTOR_ERROR';

export const UPDATE_WEAVEFACTOR_REQUEST = 'UPDATE_WEAVEFACTOR_REQUEST';
export const UPDATE_WEAVEFACTOR_DATA = 'UPDATE_WEAVEFACTOR_DATA';
export const UPDATE_WEAVEFACTOR_ERROR = 'UPDATE_WEAVEFACTOR_ERROR';

export const DELETE_WEAVEFACTOR_REQUEST = 'DELETE_WEAVEFACTOR_REQUEST';
export const DELETE_WEAVEFACTOR_DATA = 'DELETE_WEAVEFACTOR_DATA';
export const DELETE_WEAVEFACTOR_ERROR = 'DELETE_WEAVEFACTOR_ERROR';
